import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

function Redirect({ links }) {
  const { shortCode } = useParams();

  useEffect(() => {
    // Check if short code exists and redirect
    if (links[shortCode]) {
      window.location.href = links[shortCode];
    }
  }, [shortCode, links]);

  // If short code not found, show 404
  if (!links[shortCode]) {
    return (
      <div style={styles.container}>
        <h1 style={styles.h1}>404 - Link Not Found</h1>
        <p style={styles.p}>The short code "<strong>{shortCode}</strong>" does not exist.</p>
        <a href="/" style={styles.link}>← Go back to home</a>
      </div>
    );
  }

  return <div style={styles.redirecting}>Redirecting...</div>;
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    margin: 0,
    background: '#ffffff',
    flexDirection: 'column',
    textAlign: 'center',
    fontFamily: "'Inter', sans-serif",
  },
  redirecting: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#ffffff',
    color: '#333333',
    fontSize: '1.5rem',
    fontFamily: "'Inter', sans-serif",
    fontWeight: '600',
  },
  h1: {
    color: '#f56565',
    fontSize: '2rem',
    fontWeight: '600',
  },
  p: {
    color: '#666666',
    fontSize: '1rem',
  },
  link: {
    color: '#367c2b',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '1rem',
    marginTop: '20px',
  },
};

export default Redirect;
